import { ResolveOptionSubmitActionResultType } from '../../resolveOptionSubmitAction';

export const resolveValueOptionSubmitAction = (
  value: string
): ResolveOptionSubmitActionResultType => ({
  action: { type: 'value', value },
  shouldReopenDropdownAfterSubmit: false,
});
